
export const NewTimeLine = ({ data }) => (
    <div className="timeline-item">
        <div className="timeline-item-content">
            <h2 className="titleHeading">{data.title}</h2>
            <p>{data.cardDetailedText}</p>
            <span className="circle" />
        </div>
    </div>
);